import { jsx as _jsx } from "react/jsx-runtime";
import { VisibleLayoutContext } from "../Layout/VisibleLayoutContext";
import { AllLayoutCellMapContext, VisibleLayoutCellMapContext, } from "./LayoutCellMapContext";
import { LayoutGridType } from "./LayoutGridType";
import { LayoutRow } from "./LayoutRow";
import { ReactPageLayoutDebug } from "./ReactPageLayoutDebug";
import { useComputeVisibleLayout } from "./useComputeVisibleLayout";
import { useLayoutCellMap } from "./useLayoutCellMap";
export function ReactPageLayoutStrategy(props) {
    const visibleLayout = useComputeVisibleLayout(props.layout);
    const allLayoutCellMap = useLayoutCellMap(props.layout);
    const visibleLayoutCellMap = useLayoutCellMap(visibleLayout);
    return (_jsx(ReactPageLayoutDebug, { layout: visibleLayout, children: _jsx(AllLayoutCellMapContext.Provider, { value: allLayoutCellMap, children: _jsx(VisibleLayoutCellMapContext.Provider, { value: visibleLayoutCellMap, children: _jsx(VisibleLayoutContext.Provider, { value: visibleLayout, children: visibleLayout.rows.map((node) => (_jsx(LayoutRow, { node: node, gridType: LayoutGridType.Layout }, node.id))) }) }) }) }));
}
//# sourceMappingURL=ReactPageLayoutStrategy.js.map